import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ReactSVG } from "react-svg";
import { useMemo } from 'react';

import { useTheme } from '@mui/material/styles';
import { List, ListItem, Typography } from '@mui/material';
import { getStyles } from "../../../../styles/subsidebar/styles";
import '../../../../styles/subsidebar/styles.css';
import { IconSvg } from '../../../../utils/globalIcons';
import { useAppContext } from '../../../../context/AppContext';

function SubSidebar({ handleMenuChange, setSelectedMenuItem, selectedMenuItem, unlockedSteps }) {

    const theme = useTheme();
    const styles = getStyles(theme);
    const location = useLocation();
    const { selectedWorkspace, selectedProject } = useAppContext();

    const menuItems = [
        { icon: IconSvg.flagIcon, label: 'Get Started', engine_name: "", icon_type: "svg", path: 'chatbot_home' },
        { icon: IconSvg.aidatasetIcon, label: 'Select Datasets', engine_name: "", icon_type: "svg", path: 'datasets' },
        { icon: IconSvg.stylingIcon, label: 'Branding', engine_name: "", icon_type: "svg", path: 'branding' },
        { icon: IconSvg.authenticationIcon, label: 'Security', engine_name: "", icon_type: "svg", path: 'security' },
        { icon: IconSvg.launchIcon, label: 'Test & Launch', engine_name: "", icon_type: "svg", path: 'test_launch' },
    ];

    const filteredMenuItems = useMemo(() => {
        if (!selectedWorkspace || !selectedProject) return [];

        const selected_engine_name = selectedProject?.payload?.configuration?.engine_name;
        const selected_sidebar_items = selectedProject?.payload?.configuration?.engine_config?.sidebar_items ?? {};
        const sub_sidebar_items = selected_sidebar_items?.['ai_app'] ?? [];

        return menuItems
            .filter(item => sub_sidebar_items.map(subItem => subItem?.toLowerCase()).includes(item.path.toLowerCase()))
            .map(item => ({ ...item, engine_name: selected_engine_name }));
    }, [selectedWorkspace, selectedProject]);

    useEffect(() => {
        const pathParts = location.pathname.split('/');
        const currentPath = pathParts[pathParts.length - 1];
        const items = filteredMenuItems;
        const index = items.findIndex(item => item?.path?.toLowerCase()?.replace(/_/g, '-') === currentPath.toLowerCase());

        if (index !== -1 && index !== selectedMenuItem) {
            setSelectedMenuItem(index);
        }
    }, [location.pathname, selectedProject]);

    const handleMenuItemClick = (index, engine, path) => {
        setSelectedMenuItem(index);
        handleMenuChange(engine, path)
    };

    return (
        <nav style={styles.sidebar}>
            <List>
                {(filteredMenuItems || [])?.length > 0 &&
                    filteredMenuItems?.map((item, index) => {
                        const isDisabled = !unlockedSteps.includes(index);
                        return (
                            <ListItem
                                key={index}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '10px 20px',
                                    width: '170px',
                                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                                    marginBottom: '25px',
                                    backgroundColor: selectedMenuItem === index ? '#0B51C5' : '#DEDEDE',
                                    opacity: isDisabled ? 0.4 : 1,
                                    pointerEvents: isDisabled ? 'none' : 'auto',
                                    borderTopLeftRadius: '20px',
                                    borderBottomLeftRadius: '20px',
                                    position: 'relative',
                                    transition: 'background-color 0.3s ease',

                                    '&::after': {
                                        content: '""',
                                        position: 'absolute',
                                        right: '-25px',
                                        top: 0,
                                        width: '25px',
                                        height: '100%',
                                        backgroundColor: selectedMenuItem === index ? '#0B51C5' : '#DEDEDE',
                                        clipPath: 'polygon(0 0, 100% 50%, 0 100%)',
                                    },
                                }}
                                onClick={() => !isDisabled && handleMenuItemClick(index, item.engine_name, item.path)}
                            >
                                <ReactSVG
                                    style={{ marginRight: '10px' }}
                                    src={item.icon}
                                    beforeInjection={(svg) => {
                                        svg.setAttribute('style', 'width:18px; height:18px; display:block;');
                                        svg.setAttribute('stroke', selectedMenuItem === index ? '#FFFFFF' : '#000000');
                                    }}
                                />
                                <Typography
                                    sx={{
                                        ...styles.siebarLabelText,
                                        color: selectedMenuItem === index ? '#FFFFFF' : isDisabled ? '#888888' : '#000000'
                                    }}
                                >
                                    {item.label}
                                </Typography>
                            </ListItem>
                        )
                    })}
            </List>
        </nav >
    );
}

export default SubSidebar;